module.exports = __webpack_public_path__ + "images/bold-button.71b098acb096b8058d4fb55576819fbb.svg";